import React from "react";
import ReactDOM from "react-dom";

/* SCSS */
import "antd/dist/antd.css";
import "./assets/scss/style.scss";

import App from "./App";
import AreaContextProvider from "./contexts/AreaContextProvider";
import AuthContextProvider from "./contexts/AuthContextProvider";
import BannerContextProvider from "./contexts/BannerContextProvider";
import BestSellerProductContextProvider from "./contexts/BestSellerProductContextProvider";
import CampaignContextProvider from "./contexts/CampaignContextProvider";
import CategoryContextProvider from "./contexts/CategoryContextProvider";
import ChattingContextProvider from "./contexts/ChattingContextProvider";
import CompanyContextProvider from "./contexts/CompanyContextProvider";
import CustomerGroupContextProvider from "./contexts/CustomerGroupContextProvider.js";
import DailyDealsProductContextProvider from "./contexts/DailyDealsProductContextProvider";
import DeliveryPartnerContextProvider from "./contexts/DeliveryPartnerContextProvider";
import DeliveryPartnerLedgerContextProvider from "./contexts/DeliveryPartnerLedgerContextProvider";
import FeaturedProductContextProvider from "./contexts/FeaturedProductContextProvider";
import GlobalConfigContextProvider from "./contexts/GlobalConfigContextProvider";
import HomePageProductContextProvider from "./contexts/HomePageProductContextProvider";
import OrderContextProvider from "./contexts/OrderContextProvider";
import ProductBundleOfferContextProvider from "./contexts/ProductBundleOfferContextProvider";
import ProductContextProvider from "./contexts/ProductContextProvider";
import PromoCodeContextProvider from "./contexts/PromoCodeContextProvider";
import RoleContextProvider from "./contexts/RoleContextProvider";
import SellerContextProvider from "./contexts/SellerContextProvider";
import SellerLedgerContextProvider from "./contexts/SellerLedgerContextProvider";
import StaticPageContextProvider from "./contexts/StaticPageContextProvider";
import StockContextProvider from "./contexts/StockContextProvider";
import StockOutContextProvider from "./contexts/StockOutContextProvider";
import SubscriptionPlanContextProvider from "./contexts/SubscriptionPlanContextProvider";
import UserContextProvider from "./contexts/UserContextProvider";
import WarehouseContextProvider from "./contexts/WarehouseContextProvider";
import * as serviceWorker from "./serviceWorker";

const contextProviders = [
	AuthContextProvider,
	ProductContextProvider,
	UserContextProvider,
	BannerContextProvider,
	CategoryContextProvider,
	CompanyContextProvider,
	OrderContextProvider,
	RoleContextProvider,
	HomePageProductContextProvider,
	FeaturedProductContextProvider,
	DailyDealsProductContextProvider,
	BestSellerProductContextProvider,
	WarehouseContextProvider,
	StaticPageContextProvider,
	GlobalConfigContextProvider,
	StockContextProvider,
	PromoCodeContextProvider,
	StockOutContextProvider,
	SellerContextProvider,
	ChattingContextProvider,
	AreaContextProvider,
	SubscriptionPlanContextProvider,
	SellerLedgerContextProvider,
	ProductBundleOfferContextProvider,
	DeliveryPartnerContextProvider,
	DeliveryPartnerLedgerContextProvider,
	CustomerGroupContextProvider,
	CampaignContextProvider,
];

const getAppWithContextProviders = () => {
	let result = <App />;
	contextProviders.forEach(
		(Provider) => (result = <Provider>{result}</Provider>),
	);

	return result;
};

ReactDOM.render(
	// <React.StrictMode>
	getAppWithContextProviders(),
	// </React.StrictMode>
	document.getElementById("root"),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();

//KiE4fkJ08O7tL25Qer
